export default __webpack_public_path__ + "media/images/filtre-eaa54a8a86c41357ccd1723e42d35104.png";